export default __webpack_public_path__ + "images/L7.27b6cba.png";